import { Dispatch, SetStateAction, useEffect, useRef } from 'react';

export function useCloseDropdown(
  setShowDropdown: Dispatch<SetStateAction<boolean>>
) {
  const inputContainerRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: any) {
      if (
        inputContainerRef.current &&
        !inputContainerRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return inputContainerRef;
}
